export default __webpack_public_path__ + "static/banner-finance-on-demand-expectations-9f8f8ba790e2d55fb6658136a0704804.jpg";